import { getLevelData } from "../helpers/level";
import { Map } from "../objects/map";
import { Message } from "../objects/message";
import { Player } from "../objects/player";
import { UI } from "../objects/ui";

export function registerGamePlayScene({ k, name, c }) {
	// this is a 2d game with no gravity needed
	k.setGravity(0);

	k.scene(name, (level) => {
		// loading the level data to adjust the difficulty based on the level
		k.data = structuredClone({
			...k.data,
			...getLevelData(level),
		});

		const background_sound = k.play("background");

		// creating the map
		Map({ k, c, level });

		// creating the first message
		!k.data.game_played &&
			level === 1 &&
			Message({
				k,
				text: 'Welcome to the game! Let me tell you a secret, "If you are stuck, watchout for the hints"',
			});

		k.data.game_played = true;

		const player = Player({ k, c });

		const ui = UI({ k, c, level });

		// start god mode
		k.onKeyPress("g", () => {
			k.data.god_mode = !k.data.god_mode;
			if (!k.data.god_mode_found) {
				k.data.god_mode_found = true;
				Message({
					k,
					c,
					text: "Thanks for reading the entire README.md. Here is a treat for you, you are invincible, any ghost touch in this mode will vanish.",
					onKeyPress: () => {
						k.go(name, level);
					},
				});
			} else {
				k.go(name, level);
			}
		});

		k.onUpdate(() => {
			// if game is completed
			if (k.data.fuse_dropped >= k.data.fuse_needed) {
				if (level < c.MAX_LEVEL) {
					k.go("promotion", level);
				} else {
					k.go("gamecomplete");
				}
			}

			if (k.data.life <= 0) {
				background_sound.stop();
				k.go("gameover", level);
			}
		});
	});
}
